<template>
  <div id="report-view" v-loading="loading">
    <h3>Scheduled Report Form - {{ $route.params.id ? 'Edit' : 'Create' }}</h3>
    <hr class="my-4" />
    <div id="form-container" class="pt-2">
      <el-form
        ref="elForm"
        size="medium"
        label-width="auto"
        class="flex space-x-0 space-y-2 lg:space-x-2 lg:space-y-0"
        label-position="top"
        :model="form"
        :rules="formRules"
      >
        <div class="w-1/2 flex flex-col space-y-2">
          <div id="scheduleForm" class="w-full border border-lg rounded-lg">
            <h5
              class="text-base font-bold text-black border-b-2 bg-gray-200 p-4"
            >
              Schedule Details
            </h5>
            <div class="w-full flex flex-col space-y-2 p-4">
              <el-form-item label="Name " prop="SchedulerName">
                <el-input
                  v-model="form.SchedulerName"
                  placeholder="Name"
                  clearable
                />
              </el-form-item>
              <div class="w-full flex space-x-2">
                <el-form-item class="w-full" label="Period" prop="Period">
                  <el-select
                    v-model="form.Period"
                    placeholder="Select Report Period"
                    clearable
                  >
                    <el-option
                      v-for="item in dateOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="Day"
                  label="Every"
                  class="w-full"
                  v-if="form.Period == 'weekly'"
                >
                  <el-select
                    v-model="form.Day"
                    placeholder="Select the Day"
                    class="w-full"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in dayOfWeek"
                      :key="item"
                      :label="item"
                      :value="index"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="Day"
                  label="Every"
                  class="w-full"
                  v-if="form.Period == 'monthly'"
                >
                  <el-select
                    v-model="form.Day"
                    placeholder="Select the Date"
                    class="w-full"
                    clearable
                  >
                    <el-option
                      v-for="days in 30"
                      :key="days"
                      :label="days"
                      :value="days"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>

          <div id="email details" class="w-full border border-lg rounded-lg">
            <h5
              class="text-base font-bold text-black border-b-2 bg-gray-200 p-4"
            >
              Email Details
            </h5>
            <div
              class="w-full flex flex-col space-x-0 space-y-2 lg:space-x-0 lg:space-y-0 p-4"
            >
              <el-form-item label="Send To" prop="Email">
                <p class="text-xs text-red-400">
                  Must to valid Switch corporate e-mail address, no external
                  addresses permitted
                </p>

                <el-select
                  class="w-full"
                  v-model="form.Email"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  placeholder="Type email here"
                >
                  <el-option
                    v-for="item in EmailList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <!-- <el-input
                  class="w-full"
                  v-model="form.Email"
                  placeholder="Send To"
                  clearable
                ></el-input> -->
              </el-form-item>
              <el-form-item label="Subject" prop="Subject">
                <el-input
                  v-model="form.Subject"
                  placeholder="Subject"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Message" prop="Message">
                <quill-editor
                  ref="myQuillEditor"
                  v-model="form.Message"
                  :options="editorOption"
                />
              </el-form-item>
            </div>
          </div>
        </div>

        <div id="reportForm" class="w-1/2 border border-lg rounded-lg">
          <h5 class="text-base font-bold text-black border-b-2 bg-gray-200 p-4">
            Report Filter Details
          </h5>
          <div class="w-full flex flex-col space-y-2 p-4">
            <el-form-item label="Report Type" prop="ReportTitle">
              <el-input
                disabled
                v-model="form.ReportTitle"
                clearable
              ></el-input>
              <!-- <el-select
                v-model="form.ParamJsonObject.reportType"
                disabled
                filterable
                clearable
                remote
                reserve-keyword
                placeholder="Search Report"
                :loading="loading"
              >
                <el-option
                  v-for="item in reports"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select> -->
            </el-form-item>

            <el-form-item label="Report Period" prop="ParamJsonObject.dataForm">
              <el-select
                v-model="form.ParamJsonObject.dataForm"
                @change="onChangePicker"
                placeholder="Select Report Period"
                class="w-full mt-2"
              >
                <el-option
                  v-for="item in dateOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <label
              for="ParamJsonObject.startDate"
              class="el-form-item__label pb-0 mb-0"
              >Period Range</label
            >
            <div class="flex justify-between">
              <el-form-item prop="ParamJsonObject.startDate">
                <el-date-picker
                  v-model="form.ParamJsonObject.startDate"
                  class="mr-1"
                  :picker-options="datePickerOptions"
                  :type="periodDatePickerType"
                  placeholder="Start Period"
                  value-format="yyyy-MM-dd"
                  @change="validateDate"
                />
              </el-form-item>
              <el-form-item prop="ParamJsonObject.endDate">
                <el-date-picker
                  v-model="form.ParamJsonObject.endDate"
                  class="ml-1"
                  :picker-options="datePickerOptions"
                  :type="periodDatePickerType"
                  placeholder="End Period"
                  value-format="yyyy-MM-dd"
                  @change="validateDate"
                />
              </el-form-item>
            </div>

            <el-form-item
              label="Location"
              prop="ParamJsonObject.location"
              v-if="form.ParamJsonObject.location"
            >
              <el-cascader
                v-model="form.ParamJsonObject.location"
                class="w-full"
                clearable
                filterable
                disabled
                :options="location"
                :props="cascaderProps"
              />
            </el-form-item>

            <!-- <el-form-item
              label="Tenant"
              prop="ParamJsonObject.customer"
            >
              <el-cascader
                v-model="form.ParamJsonObject.customer"
                class="w-full"
                clearable
                filterable
                disabled
                :options="customerList"
                :props="cascaderProps"
              />
            </el-form-item> -->

            <el-form-item
              label="Tenant"
              prop="ParamJsonObject.customer"
              v-if="form.ParamJsonObject.customer && !isCustomer"
            >
              <el-select
                v-model="form.ParamJsonObject.customer"
                disabled
                filterable
                clearable
                remote
                reserve-keyword
                placeholder="Select Customer"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.DcoId"
                  :label="
                    item.CustomerType == 'INTERNAL_DEPARTMENT'
                      ? item.Company + ' [' + item.Department + ']'
                      : item.Company
                  "
                  :value="item.DcoId"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="Formula" class="hidden">
              <el-input placeholder="Search Formula" v-model="filterText">
              </el-input>

              <div class="border">
                <el-tree
                  show-checkbox
                  default-expand-all
                  ref="deviceGroupsTree"
                  node-key="Dce_id"
                  highlight-current
                  empty-text="No Data"
                  :data="deviceGroups"
                  :props="deviceGroupProps"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  @check-change="onDeviceGroupChange"
                >
                </el-tree>
              </div>
            </el-form-item> -->
          </div>
        </div>
      </el-form>

      <hr class="my-4" />
      <div class="w-full text-right">
        <el-button type="primary" @click="submit">Submit</el-button>
        <el-button @click="cancel">Cancel</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import formService from '@/mixins/FormService'
import formHelper from './form-helper'
import reportFilterMixin from '@/mixins/ReportFilter'

let service
var validateMultipleEmail = (rule, value, callback) => {
  const regexExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  // https://stackblitz.com/edit/node-stjmgq?file=index.js

  if (value || (value !== undefined && value.length > 1)) {
    let pass = []
    let failed = []

    if (typeof value !== 'object') {
      if (!regexExp.test(value)) {
        failed = value
      } else {
        pass = value
      }
    } else {
      value.map((data) => {
        if (!regexExp.test(data)) {
          failed = data
        } else {
          pass = data
        }
      })
    }
    failed.length > 0
      ? callback(new Error('Email format is incorrect'))
      : callback()
  } else {
    callback(new Error('Email is required'))
  }
}
export default {
  components: {},
  mixins: [reportFilterMixin],
  created() {
    service = new formService(this, formHelper)
  },
  async mounted() {
    // this.fetchCustomer()
    this.getCustomers()
    this.getCustomSensors()
    this.getLocations()
    this.getReportTypes()
    this.setDefaultCustomerId()

    if (this.$route.params.id) {
      this.mode = 'edit'
      // autofill deviceGroupsTree
      // this.$refs.deviceGroupsTree.setCheckedKeys(
      //   this.form.ParamJsonObject.ListFormula
      // )
      // this.EmailList = await this.form.Email.split(';')
      // this.form.Email = await this.EmailList
      // console.log(this.form)
      // this.EmailList = this.form.Email.split(';')
    }
  },
  async beforeMount() {
    this.loading = true
    this.form = await service.initialFormData()
    let email = this.form.Email.split(';')
    this.EmailList = email
    this.form.Email = this.EmailList
    this.loading = false
  },
  data() {
    return {
      loading: false,
      apiGetById: this.$appInfo.api.mailList.getById,
      apiPost: this.$appInfo.api.mailList.post,
      apiPut: this.$appInfo.api.mailList.put,
      form: formHelper.getEmptyData(),
      roles: [],
      customers: [],
      mode: '',
      EmailList: [],
      isSubmit: false,
      firstLoad: true,
      dateOptions: [
        {
          value: 'daily',
          label: 'Daily'
        },
        {
          value: 'weekly',
          label: 'Weekly'
        },
        {
          value: 'monthly',
          label: 'Monthly'
        }
      ],
      dayOfWeek: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      formRules: {
        SchedulerName: [
          {
            required: true,
            message: 'Name is required',
            trigger: 'change'
          }
        ],
        Day: [
          {
            required: true,
            message: 'Day is required',
            trigger: 'change'
          }
        ],
        Period: [
          {
            required: true,
            message: 'Schedule Period is required',
            trigger: 'change'
          }
        ],
        Email: [
          {
            required: true,
            message: 'Send To Email is required',
            trigger: 'change',
            validator: validateMultipleEmail
          }
        ],
        Subject: [
          {
            required: true,
            message: 'Subject is required',
            trigger: 'blur'
          }
        ],
        ParamJsonObject: {
          reportType: [
            {
              required: true,
              message: 'Report Type is required',
              trigger: 'change'
            }
          ],
          dataForm: [
            {
              required: true,
              message: 'Report Period is required',
              trigger: 'blur'
            }
          ],
          startDate: [
            {
              required: true,
              message: 'Start Period is required',
              trigger: 'blur'
            }
          ],
          endDate: [
            {
              required: true,
              message: 'End Period is required',
              trigger: 'blur'
            }
          ],
          location: [
            {
              required: false,
              message: 'Location is required',
              trigger: 'blur'
            }
          ],
          customer: [
            {
              required: false,
              message: 'Tenant is required',
              trigger: 'blur'
            }
          ],
          ListDceId: [
            {
              required: true,
              message: 'Device Group is required',
              trigger: 'blur'
            }
          ]
        }
      },
      editorOption: {
        placeholder: 'Email Message',
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['link']
          ],
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value
          }
        }
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.userData
    }
  },
  methods: {
    async cancel() {
      this.$router.go(-1)
    },
    async submit() {
      this.$refs.elForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            this.isSubmit = true
            this.form.Email = this.form.Email.join(';')
            this.form.ModifiedBy = this.user.Username
            if (this.form.ParamJsonObject.reportType != 'Power by Customer') {
              this.form.ParamJsonObject.customer = ''
            }

            await service.submit(this.form)
            this.$message.success('Data Saved')
            this.loading = false
          } catch (e) {
            this.loading = false
            this.$message.error(e)
            console.log(e)
          }
        } else {
          this.$message.warning('Please fill in the required data')
          this.loading = false
          return false
        }
      })
    }
    // async fetchCustomer() {
    //   try {
    //     this.loading = true
    //     const res = await this.$axios.get(
    //       `${this.$appInfo.api.customer.getAll}`
    //     )
    //     this.customers = res.data
    //     this.loading = false
    //   } catch (e) {
    //     this.loading = false
    //     console.log(e)
    //   }
    // }
  },
  watch: {
    'form.Period': {
      handler(val) {
        if (!this.firstLoad) {
          if (val === 'weekly') {
            this.form.Day = 0
          } else {
            this.form.Day = 1
          }
        }

        // set first load status
        this.firstLoad = false
      }
    }
    // 'form.Email': {
    //   handler(val) {
    //     if (!this.EmailList.find((data) => data === val)) {
    //       this.EmailList.push(val)
    //     }
    //     for (var email of val) {
    //       if (!this.EmailList.find((x) => x === email)) {
    //         this.EmailList.push(email)
    //       }
    //     }
    //   }
    // }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isSubmit) {
      const answer = window.confirm(
        'Do you really want to leave? you have unsaved changes!'
      )
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>

<style>
#report-view .el-select {
  width: 100% !important;
}
#report-view .el-tree {
  max-height: 300px;
  overflow: auto;
}
#report-view .el-form-item,
#report-view .el-form-item__label {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
#report-view .el-form-item .el-form-item__error {
  display: none !important;
}
#report-view .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
